import { Tier } from '../types';

/**
 * Vorbelegung des Vertragsformulars aus dem beigesetzten Tier – geteilt von der Grab- und der
 * Kunden-Detailseite, damit die Hausregel nur an einer Stelle steht.
 *
 * Regel: Unterschriftsdatum = Beisetzungsdatum, Laufzeit 5 Jahre ab 25 kg, sonst 3 Jahre.
 * Alle Werte sind nur Vorschläge und im Formular frei änderbar.
 */

/**
 * Ab diesem Gewicht (kg) gilt ein Tier als Schwergewicht. Muss identisch zu
 * `LageplanService.schwergewichtGrenzeKg` im Backend bleiben – dort steuert dieselbe Grenze die
 * Schwergewichts-Markierung im Lageplan.
 */
export const SCHWERGEWICHT_GRENZE_KG = 25;
export const LAUFZEIT_SCHWER_JAHRE = 5;
export const LAUFZEIT_STANDARD_JAHRE = 3;

/** 5 Jahre ab 25 kg, sonst 3 Jahre – auch ohne Gewichtsangabe gilt die Standardlaufzeit. */
export const laufzeitFuerGewicht = (gewicht?: number | null): number =>
  gewicht != null && gewicht >= SCHWERGEWICHT_GRENZE_KG ? LAUFZEIT_SCHWER_JAHRE : LAUFZEIT_STANDARD_JAHRE;

/** ISO-Datum auf yyyy-mm-dd kürzen (Format der DateInput), ohne Zeitzonen-Verschiebung. */
const isoTag = (iso?: string): string => (iso ? iso.split('T')[0] : '');

export interface VertragTierDefaults {
  unterschriftsdatum: string;
  laufzeitJahre: number;
}

/** Ohne Tier bleibt das Datum leer und es gilt die Standardlaufzeit. */
export const vertragDefaultsFuerTier = (
  tier?: Pick<Tier, 'gewicht' | 'beisetzungsdatum'> | null,
): VertragTierDefaults => ({
  unterschriftsdatum: isoTag(tier?.beisetzungsdatum),
  laufzeitJahre: laufzeitFuerGewicht(tier?.gewicht),
});
